<script setup lang="ts">
interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'white' | 'muted';
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  color: 'primary',
});

const sizeClasses = {
  xs: 'size-3 border',
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-8 border-3',
  xl: 'size-12 border-4',
};

const colorClasses = {
  primary: 'border-primary border-t-transparent',
  white: 'border-white border-t-transparent',
  muted: 'border-text-muted border-t-transparent',
};
</script>

<template>
  <div
    class="rounded-full animate-spin shrink-0"
    :class="[sizeClasses[props.size], colorClasses[props.color]]"
    role="status"
    aria-label="Memuat..."
    data-testid="loading-spinner"
  >
    <span class="sr-only">Memuat...</span>
  </div>
</template>
